// import react library
import { CaretDown } from 'phosphor-react';
import { motion } from "framer-motion";
import { NavLink, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// import from redux store
import { openAddNewClassPopup, addActiveClass, getActiveClass } from '../../Redux/class/class';
import { closeSidebar } from '../../Redux/sidebar/sidebar';

// import styles
import './Sidebar.css';

// define framer motion variant
const variants = {
  open: {
    height: "auto",
    transition: {
      delay: 0.02,
      duration: 0.3,
      ease: "easeInOut",
    },
  },
  closed: {
    height: 0,
    transition: {
      delay: 0.02,
      duration: 0.3,
      ease: "easeOut",
    },
  }
};

// Define the rotation variants
const rotateVariants = {
  open: { rotate: 0 },
  closed: { rotate: -90 },
  transition: { delay: 0.02, }
};

const NavigationCard = ({ item, active }) => {
  // fetch path name from useLocation and item
  const { pathname } = useLocation()
  const staticPath = item.path.split("/")

  // fetch data and define dispatch action from redux store
  const activeClass = useSelector(getActiveClass)
  const dispatch = useDispatch()

  // convert path name into array
  const pathArray = pathname.split("/")

  // active path 
  const activePath = pathArray?.length === 2 ? pathArray[1] : pathArray[2]
  const subActivePath = pathArray[pathArray.length - 1]
  const activeStaticPath = item.id === 1 ? staticPath[1] : staticPath[0]

  return (
    <>
      <NavLink className={`navigation_card_container mues_row_space_between 
      ${activePath === activeStaticPath && "active_navigation_card"}
      ${active && "mues_row_center"}`} to={item.path} id={item.title}>
        <div className="mues_row_flex mues_column_gap_8 mues_grey_II" onClick={() => item.name === "Home" ? dispatch(closeSidebar()) : ""}>
          {item.icon}
          <h5 className={`mues_font_weight_400`}>{item.name}</h5>
        </div>
        <motion.div
          className="navigation_icon"
          initial="closed" // Initial rotation state
          animate={activePath === activeStaticPath ? "open" : "closed"} // Toggle animation based on state
          variants={rotateVariants}
        >
          {item.subNavigation && <CaretDown className='wrapper_icon 
                mues_grey_II' weight='bold' />}
        </motion.div>
        {activePath === activeStaticPath && <div className='sidebar_active_card' />}
      </NavLink>

      {item.id !== 3 && <motion.div initial="closed"
        className="sub_navigation_container"
        animate={activePath === activeStaticPath ? "open" : "close"}
        style={{ overflow: "hidden" }}
        variants={variants} exit="closed" >
        {item?.subNavigation?.map(sub => {
          // fetch static path from sub and create array from static path
          const subActiveStaticPath = sub.path?.split("/")
          const subStaticPath = subActiveStaticPath[subActiveStaticPath?.length - 1]
          return (
            <NavLink className={`mues_row_flex mues_pointer navigation_sub_item mues_column_gap_4 
            ${subActivePath === subStaticPath && "active_sub_navigation_card"}`}
              key={sub.id} to={sub.path} onClick={() => dispatch(closeSidebar())}>
              {sub.logo}
              <h6 className="mues_font_weight_400">{sub.title}</h6>
            </NavLink>
          )
        })}
      </motion.div>}
      {item.id === 3 && <motion.div initial="closed"
        className="sub_navigation_container"
        animate={activePath === activeStaticPath ? "open" : "close"}
        style={{ overflow: "hidden" }}
        variants={variants} exit="closed" >
        {item?.subNavigation?.map((sub, index) => {
          const isLastItem = index === item.subNavigation.length - 1;

          if (isLastItem) return (
            <div className='mues_row_flex mues_pointer
                mues_grey_II navigation_sub_item mues_column_gap_4 add_class_section'
              onClick={() => dispatch(openAddNewClassPopup())} key={sub.id}>
              {sub.logo}
              <h6 className="mues_font_weight_400">{sub.title}</h6>
            </div>
          )
          return (
            <NavLink className={`mues_row_flex mues_pointer
                mues_grey_II navigation_sub_item mues_column_gap_4 
                ${activeClass?.id === sub?.classId && "active_sub_navigation_card"}`}
              key={sub.id} to={sub.path} onClick={() => {
                dispatch(addActiveClass(sub.class_information))
                dispatch(closeSidebar())
              }}>
              <h6 className="mues_font_weight_400 mues_row_center">{sub.logo}</h6>
              <h6 className="mues_font_weight_400 mues_one_line_clamp">{sub.title}</h6>
            </NavLink>
          )
        })}
      </motion.div>}
    </>
  )
}

export default NavigationCard